module.exports = __webpack_public_path__ + "static/img/ren.0c27d6a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/ren.gif
// module id = yG6D
// module chunks = 0